import { jsx as s } from "react/jsx-runtime";
import * as g from "react";
import { FileText as f, FileImage as x, FileVideo as m, FileAudio as v, FileSpreadsheet as b, FileCode as j, FileArchive as w, File as F } from "lucide-react";
import { cn as l } from "../../../lib/utils.js";
const h = (t) => {
  var r;
  const e = ((r = t.split(".").pop()) == null ? void 0 : r.toLowerCase()) || "";
  return ["pdf", "doc", "docx", "txt", "rtf"].includes(e) ? f : ["jpg", "jpeg", "png", "gif", "svg", "webp", "bmp"].includes(e) ? x : ["mp4", "mov", "avi", "mkv", "webm", "flv"].includes(e) ? m : ["mp3", "wav", "ogg", "m4a", "flac"].includes(e) ? v : ["xls", "xlsx", "csv", "numbers"].includes(e) ? b : [
    "js",
    "jsx",
    "ts",
    "tsx",
    "py",
    "java",
    "cpp",
    "c",
    "html",
    "css",
    "json",
    "xml"
  ].includes(e) ? j : ["zip", "rar", "7z", "tar", "gz"].includes(e) ? w : F;
}, C = (t) => {
  var r;
  const e = ((r = t.split(".").pop()) == null ? void 0 : r.toLowerCase()) || "";
  return ["pdf"].includes(e) ? "text-lpr-red" : ["doc", "docx", "txt"].includes(e) || ["jpg", "jpeg", "png", "gif", "svg", "webp"].includes(e) ? "text-lpr-teal" : ["mp4", "mov", "avi", "mkv"].includes(e) || ["mp3", "wav", "ogg"].includes(e) ? "text-lpr-terracotta" : ["xls", "xlsx", "csv"].includes(e) ? "text-lpr-green" : ["js", "jsx", "ts", "tsx", "py", "html", "css"].includes(e) ? "text-lpr-gold" : ["zip", "rar", "7z"].includes(e) ? "text-text-secondary" : "text-lpr-teal";
}, z = (t) => {
  var r;
  const e = ((r = t.split(".").pop()) == null ? void 0 : r.toLowerCase()) || "";
  return ["pdf"].includes(e) ? "bg-lpr-red/20" : ["doc", "docx", "txt"].includes(e) || ["jpg", "jpeg", "png", "gif", "svg", "webp"].includes(e) ? "bg-lpr-teal/20" : ["mp4", "mov", "avi", "mkv"].includes(e) || ["mp3", "wav", "ogg"].includes(e) ? "bg-lpr-terracotta/20" : ["xls", "xlsx", "csv"].includes(e) ? "bg-lpr-green/20" : ["js", "jsx", "ts", "tsx", "py", "html", "css"].includes(e) ? "bg-lpr-gold/20" : ["zip", "rar", "7z"].includes(e) ? "bg-bg-muted" : "bg-lpr-aqua/20";
}, y = g.forwardRef(({ fileName: t, size: e = "md", showBackground: r = !1, className: n, ...i }, c) => {
  const o = h(t), p = C(t), d = z(t), u = {
    sm: "h-4 w-4",
    md: "h-6 w-6",
    lg: "h-8 w-8",
    xl: "h-12 w-12"
  }, a = {
    sm: "p-1.5",
    md: "p-2",
    lg: "p-3",
    xl: "p-4"
  };
  return r ? s("div", { ref: c, className: l("inline-flex items-center justify-center rounded-lg", d, a[e], n), ...i, children: s(o, { className: l(u[e], p) }) }) : s("div", { ref: c, className: l("inline-flex", n), ...i, children: s(o, { className: l(u[e], p) }) });
});
y.displayName = "FileIcon";
export {
  y as FileIcon
};
//# sourceMappingURL=FileIcons.js.map
